// extracted by extract-css-chunks-webpack-plugin
module.exports = {"videoPlaceholder":"_30UPWa"};